import React from 'react';
import { Link } from 'react-router-dom';
// import { Button } from 'reactstrap';
//Styles
import './Home.css';
//Video
import Background from '../../images/background.mp4';
//Components
import Header from '../Header/Header';


const Home = () => {


    return (
    <>
        <div className="home__background">
            <video autoPlay loop muted>
                <source src={Background} type='video/mp4' />
            </video>
        </div>
        <Header color={'var(--White)'} barColor={'var(--Lime)'} bg={'none'}/>
        <div className="home__wrapper">
            <div className="home__content">
                <div className="home__text">
                    <h3 className="home__title">
                        <div className="home__slide1"><span className="home__title1">Field-Specific / Accurate / Rapid</span></div>
                    </h3>
                    <h1 className="home__slide2"><span className="home__title2">Professional Translation Services <br/>
                    & Digital Management Solutions</span></h1>
                    <Link to='/quote'><button className="home__contactBtn">quick quote</button></Link>
                </div>
            </div>
        </div>
    </>
    );
};

export default Home;